import React, { useCallback, useContext, useRef } from 'react'
import styled from 'styled-components'
import OfferAirportSelectBox from './OfferAirportSelectBox'
import { OfferPageActions } from 'contexts/OfferPage/offerPageStateReducer'
import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'
import withOfferPageState from 'contexts/OfferPage/withOfferPageState'
import OfferPageStateTrackingContext from 'contexts/OfferPage/offerPageStateTrackingContext'
import OfferAirportSelectDropdown from './OfferAirportSelectDropdown'

const DropdownContainer = styled.div`
  position: relative;
`

interface Props {
  open: boolean;
  className?: string;
  airport?: App.Airport;
}

function OfferAirportSelect(props: Props) {
  const { open, className, airport } = props
  const trigger = useRef<HTMLButtonElement>(null)
  const dispatch = useOfferPageDispatch()
  const { trackEvent } = useContext(OfferPageStateTrackingContext)

  const closeFilter = useCallback(() => {
    dispatch({ type: OfferPageActions.closeFilter })
    trackEvent('AIRPORT_FILTER_CLOSED')
  }, [dispatch, trackEvent])

  const onAirportSelect = useCallback(() => {
    trackEvent('AIRPORT_FILTER_SELECTED')
    dispatch({ type: OfferPageActions.closeFilter })
  }, [dispatch, trackEvent])

  return (
    <DropdownContainer className={className}>
      <OfferAirportSelectBox ref={trigger} />
      <OfferAirportSelectDropdown
        open={open}
        anchorRef={trigger}
        triggerRef={trigger}
        onClose={closeFilter}
        onSelectAirport={onAirportSelect}
        selectedAirportCode={airport?.code}
      />
    </DropdownContainer>
  )
}

export default withOfferPageState(state => ({
  open: state.activeFilter === 'airport',
  airport: state.airport,
}))(OfferAirportSelect)
